
import { HeartPulse } from 'lucide-react';

export const EmergencyTypesSection = () => {
  return (
    <section className="py-12 bg-emergency-50">
      <div className="container mx-auto px-4">
        <h2 className="heading-md mb-6 text-emergency-700 text-center">Prepared for Any Situation</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 max-w-4xl mx-auto">
          <div className="p-4 bg-white rounded-lg border border-border text-center hover:border-emergency-300 transition-colors">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mx-auto mb-2 text-emergency-600">
              <path d="m9.5 4 9.5 9.5-9.5 9.5-9.5-9.5z" />
            </svg>
            <span className="text-sm">Earthquakes</span>
          </div>
          <div className="p-4 bg-white rounded-lg border border-border text-center hover:border-emergency-300 transition-colors">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mx-auto mb-2 text-emergency-600">
              <path d="M16 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
              <path d="M6 12a3 3 0 0 0 3 3c.6 0 1.4-.3 2.3-1 .9-.7 1.7-1.4 2.7-1.4a3 3 0 0 1 3 3" />
              <path d="M7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
              <path d="M16 12h.01" />
              <path d="M13 5c1 0 2.2.7 3.6 1.4a4.8 4.8 0 0 0 1.8.6H20" />
              <path d="m12 5-1.8-1.6c-.6-.5-1.4-1-2.3-.8" />
              <path d="M6 8h.01L6 8z" />
              <path d="M7 5 4.2 7.8c-.7.7-1.2 1.8-1.2 2.8 0 .6.3 1.2.8 1.6L7 15" />
            </svg>
            <span className="text-sm">Floods</span>
          </div>
          <div className="p-4 bg-white rounded-lg border border-border text-center hover:border-emergency-300 transition-colors">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mx-auto mb-2 text-emergency-600">
              <path d="m11 5-7 13a1 1 0 0 0 1 1.5h12.5c.83 0 1.3-.95.8-1.6l-6-8a1 1 0 0 0-1.6 0v-4Z" />
              <path d="M13 15h6" />
              <path d="m8 9 3 3 5-5" />
            </svg>
            <span className="text-sm">Wildfires</span>
          </div>
          <div className="p-4 bg-white rounded-lg border border-border text-center hover:border-emergency-300 transition-colors">
            <HeartPulse className="mx-auto mb-2 text-emergency-600" size={36} />
            <span className="text-sm">Medical</span>
          </div>
          <div className="p-4 bg-white rounded-lg border border-border text-center hover:border-emergency-300 transition-colors">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mx-auto mb-2 text-emergency-600">
              <path d="M5 5v.5C5 7.433 7.567 10 10.5 10" />
              <path d="M10 10h4" />
              <path d="M17 10h2" />
              <path d="M5 6c0 8 6 14 14 14" />
            </svg>
            <span className="text-sm">Hurricanes</span>
          </div>
          <div className="p-4 bg-white rounded-lg border border-border text-center hover:border-emergency-300 transition-colors">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mx-auto mb-2 text-emergency-600">
              <path d="M18.5 8c.7 0 1.4.7 1.4 1.4v6.6c0 .7-.7 1.4-1.4 1.4h-13c-.7 0-1.4-.7-1.4-1.4V13h6.4c.7 0 1.4-.7 1.4-1.4V5h3.5c.7 0 1.4.7 1.4 1.4V8Z" />
              <path d="M5.5 13V6.4c0-.7.7-1.4 1.4-1.4H10" />
            </svg>
            <span className="text-sm">Power Outages</span>
          </div>
        </div>
      </div>
    </section>
  );
};
